<template>
  <svg
    width="12px"
    height="8px"
    viewBox="0 0 12 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="btn_Primary-small-floating"
        transform="translate(-162.000000, -20.000000)"
        fill="currentColor"
      >
        <g id="Group" transform="translate(24.000000, 16.000000)">
          <g
            id="Organization-/-Status-/-checkmark-/-24"
            transform="translate(136.000000, 0.000000)"
          >
            <polygon
              id="Fill"
              points="6.66666667 10.6 3.13333333 7.06666667 2.4 7.73333333 5.93333333 11.2666667 6.66666667 12 13.7333333 4.93333333 13 4.2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Check'
};
</script>
